import { render, staticRenderFns } from "./ExistingWillChangesEstateDetails.vue?vue&type=template&id=243e1c61"
import script from "./ExistingWillChangesEstateDetails.vue?vue&type=script&lang=js"
export * from "./ExistingWillChangesEstateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports